import { tv } from '../../lib/tv';

/**
 * Figma Select trigger (50:129). Same box as Text Input; "Open" (Radix
 * `data-state=open`) and keyboard focus both show border/focus 1.5 + the
 * Focus/Input halo. Caret flips up while open.
 */
export const selectTrigger = tv({
  slots: {
    root: [
      'group/select flex w-full items-center gap-2 border border-border-strong bg-bg-surface text-left text-text-primary outline-none',
      'transition-[border-color,box-shadow] duration-[120ms] ease-out',
      'hover:border-border-strong-hover',
      'focus-visible:border-border-focus focus-visible:shadow-focus-input focus-visible:inset-ring-[0.5px] focus-visible:inset-ring-border-focus',
      'data-[state=open]:border-border-focus data-[state=open]:shadow-focus-input data-[state=open]:inset-ring-[0.5px] data-[state=open]:inset-ring-border-focus',
      'aria-expanded:border-border-focus aria-expanded:shadow-focus-input aria-expanded:inset-ring-[0.5px] aria-expanded:inset-ring-border-focus',
      'aria-invalid:border-status-danger-fg aria-invalid:inset-ring-[0.5px] aria-invalid:inset-ring-status-danger-fg',
      'disabled:cursor-not-allowed disabled:border-border-default disabled:bg-bg-disabled disabled:text-text-disabled',
    ],
    value:
      // Disabled wins over the placeholder colour (text/disabled for both, per Figma).
      'min-w-0 flex-1 truncate group-data-placeholder/select:text-text-tertiary group-disabled/select:text-text-disabled!',
    leading: 'text-icon-secondary shrink-0 group-disabled/select:text-icon-tertiary',
    caret: [
      'text-icon-secondary shrink-0 transition-transform duration-[120ms] ease-out group-disabled/select:text-icon-tertiary',
      'group-data-[state=open]/select:rotate-180 group-aria-expanded/select:rotate-180',
    ],
  },
  variants: {
    size: {
      sm: {
        root: 'text-body-sm h-8 rounded-md px-3',
        leading: 'size-4',
        caret: 'size-4',
      },
      md: {
        root: 'text-body-md h-10 rounded-md px-3',
        leading: 'size-[18px]',
        caret: 'size-[18px]',
      },
      // Large: 16 left, 12 right (Figma).
      lg: {
        root: 'text-body-lg h-12 rounded-lg pr-3 pl-4',
        leading: 'size-5',
        caret: 'size-5',
      },
    },
  },
  defaultVariants: { size: 'md' },
});
